export default __webpack_public_path__ + "static/media/shirt-front.c12cdec6.png";